export enum PromoCodeUseLimitModeEnum {
  ENTER = 'enter',
  ACTIVATION = 'activation'
}
